import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { EncryptionService } from '../../services/encryption.service';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  email: String;
  password: String;
  showmsgcheck: Boolean = false;
  msg: string = '';
  signInClicked: Boolean = false;
  valMsgSendEmail: Boolean = false;
  showStepErrMsg: Boolean = false;

  constructor(
    private auth: AuthService,
    private encryptionService: EncryptionService,
    private router: Router
  ) {}

  ngOnInit() {}

  async onLoginSubmit() {
    this.showStepErrMsg = false;
    this.valMsgSendEmail = false;

    if (!this.email) {
      this.valMsgSendEmail = true;
    }
    if (!this.email) {
      return false;
    }
    if (!this.password || !this.email) {
      this.showToast('Please enter your Email and Password');
    } else {
      this.signInClicked = true;

      try {
        // Encrypt credentials before sending
        const encryptedCredentials = await this.encryptionService.encryptCredentials(
          this.email.toString(),
          this.password.toString()
        );

        let obj = {
          encryptedCredentials: encryptedCredentials,
        };

        this.auth.authenticateUser(obj).subscribe(
          (resp) => {
            if (resp['success']) {
              if (resp['user']['accountStatus'] == 'inactive') {
                this.router.navigateByUrl('/completeprofile');
              } else if (resp['user']['changedDefaultPassword']) {
                this.router.navigateByUrl('/dashboard');
              } else {
                this.router.navigateByUrl('/changepass');
              }
            } else {
              let ss = resp['msg'];
              switch (ss) {
                case 'Wrong password':
                  this.showToast('Wrong Password.');
                  break;
                case 'User not found':
                  this.showToast('User not registerd.');
                  break;
              }
              this.signInClicked = false;
            }
          },
          (err) => {
            this.signInClicked = false;

            if (err.error && err.error.msg) {
              this.showToast(err.error.msg);
            } else {
              this.showToast('Something went wrong. Please try again later.');
            }
          }
        );
      } catch (error) {
        console.error('Encryption error:', error);
        this.showToast('Security error. Please try again.');
        this.signInClicked = false;
      }
    }
  }

  showToast(msg) {
    this.msg = msg;
    this.showmsgcheck = true;
    setTimeout(() => {
      this.showmsgcheck = false;
    }, 5000);
  }
}
